/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { Link, injectIntl } from "gatsby-plugin-intl"
import {
  UilInstagram,
  UilFacebookF,
  UilLinkedin,
  UilYoutube,
  UilWhatsapp,
} from "@iconscout/react-unicons"
import { goToUrl } from "../utils"

const Footer = ({ intl }) => {
  const data = useStaticQuery(graphql`
    query FooterQuery {
      allDirectusVariable {
        nodes {
          constants {
            address
            fax
            iva
            mail
            name
            phone
            disclaimer
            social {
              facebook
              linkedin
              instagram
              whatsapp
              youtube
            }
          }
        }
      }
    }
  `)
  const constants = data.allDirectusVariable.nodes[0].constants

  const isItaliano = () => {
    return intl.locale === 'it'
  }

  const isFromMarketing = typeof window !== "undefined" ? window.location.search.includes('mkt=1') : false

  return (
    <footer className="c-footer">
      <div className="a-container">
        <div className="c-footer__logo">
          <Link to="/">
            <img
              className="c-footer__logo__image"
              src="/logo_white_red.svg"
              alt=""
            />
          </Link>
        </div>
        {/* {intl.locale === "it" && (
          <div className="c-footer__legal c-footer__medical">
            {constants.disclaimer}
          </div>
        )} */}
        <div className="c-footer__info">
          <div className="c-footer__info__society">
            <span className="c-footer__info__society__company">
              {intl.formatMessage({ id: "company" })}
            </span>
            <span>{constants.address}</span>
            <span>{constants.iva}</span>
          </div>
          <div className="c-footer__info__contacts">
            <span>
              <span className="fw-light">
                {intl.formatMessage({ id: "terms.phone" })}
              </span>
              {constants.phone}
            </span>
            <span>
              <span className="fw-light">
                {intl.formatMessage({ id: "terms.fax" })}
              </span>
              {constants.fax}
            </span>
            <span>
              <span className="fw-light">
                {intl.formatMessage({ id: "terms.mail" })}
              </span>
              <a href={`mailto:${constants.mail}`}>{constants.mail}</a>
            </span>
          </div>
          {/* <div className="c-footer__info__social">
            {constants.social.facebook && (
              <UilFacebookF
                onClick={() => goToUrl(constants.social.facebook)}
              />
            )}
            {constants.social.instagram && (
              <UilInstagram
                onClick={() => goToUrl(constants.social.instagram)}
              />
            )}
            {constants.social.linkedin && (
              <UilLinkedin onClick={() => goToUrl(constants.social.linkedin)} />
            )}
            {constants.social.whatsapp && (
              <UilWhatsapp onClick={() => goToUrl(constants.social.whatsapp)} />
            )}
            {constants.social.youtube && (
              <UilYoutube onClick={() => goToUrl(constants.social.youtube)} />
            )}
          </div> */}
        </div>
        {isItaliano && !isFromMarketing && <div className="c-footer__legal">
          Ai sensi delle Nuove Linee guida del Ministero della Salute del 28/03/2013, relative alla pubblicità sanitaria concernente i dispositivi medici, dispositivi medico-diagnostici in vitro e presidi medico chirurgici, si avvisa l'utente che le informazioni ivi contenute sono esclusivamente rivolte agli operatori professionali.
        </div>}
        <div className="c-footer__legal">
          <div className="c-footer__legal__year">
            <Link to="/terms">
              {intl.formatMessage({ id: "terms.terms_condition" })}
            </Link></div>
          <div className="c-footer__legal__cookies">
            <Link to="/privacy">
              {intl.formatMessage({ id: "terms.cookie_privacy" })}
            </Link>
          </div>
          <div className="c-footer__legal__gabbiano">
            <Link to="https://www.gabbiano.it">
              <img src="/gabbiano_white.svg" alt="" />
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default injectIntl(Footer)
